import {Api} from "../api/InternalApi";
import {createAsyncActionTypes, createLoadDataActionCreator} from "../common/util/asyncdata/actionUtil";
import {AOIMonitor as Notification} from "./model";
import {selectors} from "./selectors";

export const LOAD_NOTIFICATIONS_PREFIX = "controlRoom/LOAD_NOTIFICATIONS";
const loadNotificationActionTypes = createAsyncActionTypes(LOAD_NOTIFICATIONS_PREFIX);

export const LOAD_NOTIFICATION_DETAIL_PREFIX = "controlRoom/LOAD_NOTIFICATION_DETAIL";
const loadNotificationDetailActionTypes = createAsyncActionTypes(LOAD_NOTIFICATION_DETAIL_PREFIX);

export const actionTypes = {
    ADD_NOTIFICATION: "controlRoom/ADD_NOTIFICATION",
    REMOVE_NOTIFICATION: "controlRoom/REMOVE_NOTIFICATION",
    PROGRESS_NOTIFICATION: "controlRoom/PROGRESS_NOTIFICATION",
    LOAD_NOTIFICATIONS_STARTED: loadNotificationActionTypes.STARTED,
    LOAD_NOTIFICATIONS_SUCCESS: loadNotificationActionTypes.SUCCESS,
    LOAD_NOTIFICATIONS_ERROR: loadNotificationActionTypes.ERROR,
    LOAD_NOTIFICATIONS_RESET: loadNotificationActionTypes.RESET,
    LOAD_NOTIFICATION_DETAIL_STARTED: loadNotificationDetailActionTypes.STARTED,
    LOAD_NOTIFICATION_DETAIL_SUCCESS: loadNotificationDetailActionTypes.SUCCESS,
    LOAD_NOTIFICATION_DETAIL_ERROR: loadNotificationDetailActionTypes.ERROR,
    LOAD_NOTIFICATION_DETAIL_RESET: loadNotificationDetailActionTypes.RESET,
};

const addNotification = (service: Notification) => {
    return {
        type: actionTypes.ADD_NOTIFICATION,
        payload: {
            service,
        },
    };
};

const removeNotification = (serviceId: string) => {
    return {
        type: actionTypes.REMOVE_NOTIFICATION,
        payload: {
            id: serviceId,
        },
    };
};

const progressNotification = (serviceId: string, progress: string) => {
    return {
        type: actionTypes.PROGRESS_NOTIFICATION,
        payload: {
            id: serviceId,
            progress,
        },
    };
};

const cancelNotification = (serviceId: string) => {
    return (dispatch, getState, {getApi}) => {
        const api = getApi(getState());
        return api.cancelNotification(serviceId);
    };
};

const refreshNotifications = () => {
    return (dispatch, getState, {getApi}) => {
        const api = getApi(getState());
        return api.loadAOINotifications().then(
            (payload) => {
                dispatch(
                    {type: actionTypes.LOAD_NOTIFICATIONS_SUCCESS, payload, error: false});
                return payload;
            },
        ).catch(
            (error) => {
                dispatch({type: actionTypes.LOAD_NOTIFICATIONS_ERROR, payload: error, error: true});
                throw error;
            },
        ) as Promise<Notification[]>;
    }
}

const refreshNotification = (id: string) => {
    return (dispatch, getState, {getApi}) => {
        const api = getApi(getState());
        return api.getNotificationById(id).then(
            (payload) => {
                dispatch(
                    {type: actionTypes.LOAD_NOTIFICATION_DETAIL_SUCCESS, payload, error: false});
                return payload;
            },
        ).catch(
            (error) => {
                dispatch({type: actionTypes.LOAD_NOTIFICATION_DETAIL_ERROR, payload: error, error: true});
                throw error;
            },
        ) as Promise<Notification>;
    }
}

const loadNotifications = createLoadDataActionCreator(LOAD_NOTIFICATIONS_PREFIX, (api) => api.loadAOINotifications, selectors.getNotificationRequestState);

const deleteNotification = (id: string) => {
    return (dispatch, getState, {getApi}) => {
        const api: Api = getApi(getState());
        return api.deleteAOINotification(id).then(() => {
            dispatch(actions.refreshNotifications());
        });
    };
};

export const actions = {
    addNotification,
    removeNotification,
    progressNotification,
    cancelNotification,
    refreshNotifications,
    refreshNotification,
    loadNotifications,
    deleteNotification,
};